import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.a`
  background: ${props => props.theme.palette.secondary.main};
  border-radius: 50px;
  color: #fff;
  padding: 16px 24px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  border: none;
  outline: none;
  display: block;
  margin: ${props => props.margin}px auto 0;
  transition: transform 0.3s;
  text-decoration: none;
  width: max-content;

  &:hover {
    transform: scale(1.1);
  }
`;

export const MainButton = ({ text, href, margin = 32 }) => {
  return (
    <StyledButton margin={margin} href={href} target={'_blank'}>
      {text}
    </StyledButton>
  );
};
